import { IPoint } from '@/utils/gis/types';

export function isValidPolygonPath(path: IPoint[]): boolean {
  return path.length >= 3;
}
